import { component } from 'picoapp';
import Drawer from 'utils/drawer';
import CartHandler, { Config } from 'utils/cart';

export default component(async (node) => {
  const cartDrawer = Drawer(node);
  const openButtons = document.querySelectorAll('[data-open="cart"]');
  const closeButton = node.querySelector('[data-close]');

  const cartConfig:Config = {
    lineItemListElement: node.querySelector('[data-cart-items]'),
    savingsDisplay: node.querySelector('[data-savings]'),
    subtotalDisplay: node.querySelector('[data-subtotal]'),
    shippingDisplay: node.querySelector('[data-shipping]'),
    totalDisplay: node.querySelector('[data-total]'),
    lineItemCounters: [...document.querySelectorAll('[data-lineitems-count]') as NodeListOf<HTMLElement>],
    submitCheckoutButton: node.querySelector('[name="checkout"]'),
    termsCheckbox: node.querySelector('[data-terms-checkbox]'),
    shippingBarStatus: node.querySelector('[data-shipping-status]'),
    shippingProgressbar: node.querySelector('[data-shipping-bar]'),
    shippingThreshold: parseInt(node.querySelector('[data-threshold]')?.getAttribute('data-threshold'), 10),
  };

  const cartManager = new CartHandler(cartConfig);

  cartManager.init();

  cartDrawer.on('opened', () => {
    document.dispatchEvent(new Event('cart:opened'));
  });

  cartDrawer.on('open', async () => {
    const disableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default.disablePageScroll;
    disableScroll(node);
  });

  cartDrawer.on('close', async () => {
    const enableScroll = (await import(
      /* webpackChunkName: "scroll-lock" */
      'modules/scroll-lock'
    )).default;

    enableScroll.clearQueueScrollLocks();
    enableScroll.enablePageScroll(node);

    document.dispatchEvent(new Event('cart:close'));
  });

  openButtons.forEach((button) => {
    button.addEventListener('click', () => {
      cartDrawer.open();
    });
  });

  closeButton.addEventListener('click', () => {
    cartDrawer.close();
  });

  document.addEventListener('cart:state:updated', (e:CustomEvent) => {
    const { detail: count } = e;
    node.setAttribute('data-items', count);
  });

  document.addEventListener('cart:add:variant', (e:CustomEvent) => {
    const { detail } = e;

    cartManager.addVariant({
      items: detail.items,
    });

    cartDrawer.open();
  });

  const params = new URLSearchParams(window.location.search);
  if (params.get('cart') !== null) {
    cartDrawer.open();
  }
});
